import React from "react";

export default function AlertRed(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.594"
      height="16.013"
      fill="none"
      viewBox="0 0 17.594 16.013"
      {...props}
    >
      <path
        fill="#979797"
        fillRule="evenodd"
        d="M3 16.013A3 3 0 01.405 11.51L6.201 1.498a3 3 0 015.192 0L17.19 11.51a3 3 0 01-2.596 4.503zM8 6a1 1 0 112 0v2a1 1 0 11-2 0zm1 4a1.25 1.25 0 100 2.5A1.25 1.25 0 009 10z"
        clipRule="evenodd"
      >
      </path>
      <mask
        id="mask0_120_23347"
        width="18"
        height="17"
        x="3"
        y="4"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M6 20.013a3 3 0 01-2.596-4.503L9.201 5.498a3 3 0 015.192 0L20.19 15.51a3 3 0 01-2.596 4.503zM11 10a1 1 0 112 0v2a1 1 0 11-2 0zm1 4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
          clipRule="evenodd"
        >
        </path>
      </mask>
      <g mask="url(#mask0_120_23347)" transform="translate(-3 -4)">
        <path fill="#ea213a" d="M0 0H24V24H0z"></path>
      </g>
    </svg>
  );
}
